'use strict';

module.controller(
                'MainCtrl',
                [
                        '$scope',
                        '$rootScope',
                        '$state',
                        'securityService',
                        'alertService',
                        '$interval',
                        'uiTinymceConfig',
                        '$rootScope',
                        function($scope, $rootScope, $state, securityService, alertService, $interval, uiTinymceConfig) {

                            $rootScope.pageSize = 20;

                            // **Setting Tinymce Editor**//
                            uiTinymceConfig.baseURL = "scripts/plugins/tinymce";
                            uiTinymceConfig.theme_url = "scripts/plugins/tinymce/themes/modern/theme.min.js";
                            uiTinymceConfig.skin_url = "scripts/plugins/tinymce/skins/lightgray";
                            uiTinymceConfig.language = 'es';
                            uiTinymceConfig.language_url = 'scripts/plugins/tinymce/langs/es.js';
                            uiTinymceConfig.plugins = "table textcolor";
                            uiTinymceConfig.menubar = "false";
                            uiTinymceConfig.toolbar1 = "undo redo | bold italic underline strikethrough | formatselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor";
                            uiTinymceConfig.extended_valid_elements = "b/strong";
                            uiTinymceConfig.style_formats = [ {
                                title : 'Bold text',
                                inline : 'b'
                            } ];
                            uiTinymceConfig.formats = {
                                bold : {
                                    inline : 'b'
                                }
                            };
                            
                                                  	
                        } ]);

